export const iconFontAwesomePhotosImagesEyeSlash = (
	<i className="fa-solid fa-eye-slash"></i>
);
